export const createMarkup = (html) => ({ __html: html })